// extracted by mini-css-extract-plugin
module.exports = {"footer":"CardFooter_footer__1EdOI py-4 px-6"};